<script>
  export let assetsPath = './';
  let width = null;
  import { onMount } from 'svelte';
  export let onAiMounted = () => {};
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-quads-box" bind:clientWidth={width}>
  <!-- Artboard: xs -->
  {#if width && width >= 0 && width < 660}
    <div id="g-quads-xs" class="g-artboard" style="">
      <div style="padding: 0 0 197.2727% 0;"></div>
      <div
        id="g-quads-xs-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/quads-xs.jpg);"
      ></div>
      <div
        id="g-ai0-1"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:2.2739%;margin-top:-6.8px;right:81.2044%;width:67px;"
      >
        <p class="g-pstyle0">Toe Loop</p>
      </div>
      <div
        id="g-ai0-2"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:2.3807%;margin-top:-6.5px;right:66.3417%;width:64px;"
      >
        <p class="g-pstyle0">Salchow</p>
      </div>
      <div
        id="g-ai0-3"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:2.3807%;margin-top:-6.5px;right:54.3268%;width:44px;"
      >
        <p class="g-pstyle0">Lutz</p>
      </div>
      <div
        id="g-ai0-4"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:2.3807%;margin-top:-6.5px;right:38.3829%;width:41px;"
      >
        <p class="g-pstyle0">Flip</p>
      </div>
      <div
        id="g-ai0-5"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:2.3807%;margin-top:-6.5px;right:22.8372%;width:47px;"
      >
        <p class="g-pstyle0">Loop</p>
      </div>
      <div
        id="g-ai0-6"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:2.3807%;margin-top:-6.5px;right:5.4887%;width:44px;"
      >
        <p class="g-pstyle0">Axel</p>
      </div>
      <div
        id="g-ai0-7"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:5.8077%;margin-top:-6.8px;left:4.6245%;width:68px;"
      >
        <p class="g-pstyle1">Toe jump</p>
      </div>
      <div
        id="g-ai0-8"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:13.287%;margin-top:-6.5px;left:18.2068%;width:76px;"
      >
        <p class="g-pstyle1">Edge jump</p>
      </div>
      <div
        id="g-ai0-9"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:16.1892%;margin-top:-12.4px;left:79.8466%;width:73px;"
      >
        <p class="g-pstyle2">Forewards</p>
        <p class="g-pstyle2">takeoff</p>
      </div>
      <div
        id="g-ai0-10"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:21.1047%;margin-top:-12.4px;left:3.4829%;width:78px;"
      >
        <p class="g-pstyle2">Backwards</p>
        <p class="g-pstyle2">takeoff</p>
      </div>
      <div
        id="g-ai0-11"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:28.9985%;margin-top:-6.8px;left:1.0646%;width:52px;"
      >
        <p class="g-pstyle3">1988</p>
      </div>
      <div
        id="g-ai0-12"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:44.0217%;margin-top:-6.6px;left:17.9408%;width:51px;"
      >
        <p class="g-pstyle3">1998</p>
      </div>
      <div
        id="g-ai0-13"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:64.759%;margin-top:-6.6px;left:34.0329%;width:49px;"
      >
        <p class="g-pstyle3">2011</p>
      </div>
      <div
        id="g-ai0-14"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:71.825%;margin-top:-6.6px;left:64.7174%;width:51px;"
      >
        <p class="g-pstyle3">2016</p>
      </div>
      <div
        id="g-ai0-15"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:77.6495%;margin-top:-6.5px;right:3.4795%;width:84px;"
      >
        <p class="g-pstyle4">4.5 rotations</p>
      </div>
      <div
        id="g-ai0-16"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:81.7806%;margin-top:-12.4px;left:12.2553%;margin-left:-39px;width:78px;"
      >
        <p class="g-pstyle5">Land on</p>
        <p class="g-pstyle5">same skate</p>
      </div>
      <div
        id="g-ai0-17"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:82.5777%;margin-top:-6.6px;left:80.7798%;width:53px;"
      >
        <p class="g-pstyle3">2022</p>
      </div>
      <div
        id="g-ai0-18"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:91.6117%;margin-top:-12.4px;left:28.697%;margin-left:-47px;width:94px;"
      >
        <p class="g-pstyle5">Land on</p>
        <p class="g-pstyle5">opposite skate</p>
      </div>
      <div
        id="g-ai0-19"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:96.7098%;margin-top:-6.6px;left:26.7004%;width:169px;"
      >
        <p class="g-pstyle6">All jumps land backwards</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: md -->
  {#if width && width >= 660 && width < 930}
    <div id="g-quads-md" class="g-artboard" style="">
      <div style="padding: 0 0 49.697% 0;"></div>
      <div
        id="g-quads-md-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/quads-md.jpg);"
      ></div>
      <div
        id="g-ai1-1"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:8.7137%;margin-top:-12.6px;left:85.7499%;width:112px;"
      >
        <p class="g-pstyle0">All jumps</p>
        <p class="g-pstyle0">land backwards</p>
      </div>
      <div
        id="g-ai1-2"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:9.9332%;margin-top:-6.6px;left:19.6999%;width:51px;"
      >
        <p class="g-pstyle1">1980</p>
      </div>
      <div
        id="g-ai1-3"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:9.9332%;margin-top:-6.6px;left:34.0378%;width:51px;"
      >
        <p class="g-pstyle1">1990</p>
      </div>
      <div
        id="g-ai1-4"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:9.9332%;margin-top:-6.6px;left:48.3755%;width:55px;"
      >
        <p class="g-pstyle1">2000</p>
      </div>
      <div
        id="g-ai1-5"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:9.9332%;margin-top:-6.6px;left:62.7135%;width:51px;"
      >
        <p class="g-pstyle1">2010</p>
      </div>
      <div
        id="g-ai1-6"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:9.9332%;margin-top:-6.6px;left:77.0514%;width:54px;"
      >
        <p class="g-pstyle1">2020</p>
      </div>
      <div
        id="g-ai1-7"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:21.1561%;margin-top:-12.4px;left:17.0858%;width:78px;"
      >
        <p class="g-pstyle2">Backwards</p>
        <p class="g-pstyle2">takeoff</p>
      </div>
      <div
        id="g-ai1-8"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:21.7658%;margin-top:-12.4px;right:12.7243%;width:78px;"
      >
        <p class="g-pstyle3">Land on</p>
        <p class="g-pstyle3">same skate</p>
      </div>
      <div
        id="g-ai1-9"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:24.5421%;margin-top:-6.5px;right:92.4635%;width:67px;"
      >
        <p class="g-pstyle4">Toe Loop</p>
      </div>
      <div
        id="g-ai1-10"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:28.8357%;margin-top:-6.6px;left:29.424%;width:51px;"
      >
        <p class="g-pstyle5">1988</p>
      </div>
      <div
        id="g-ai1-11"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:28.8104%;margin-top:-6.5px;left:10.0019%;width:68px;"
      >
        <p class="g-pstyle6">Toe jump</p>
      </div>
      <div
        id="g-ai1-12"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:34.5707%;margin-top:-12.4px;right:12.749%;width:94px;"
      >
        <p class="g-pstyle3">Land on</p>
        <p class="g-pstyle3">opposite skate</p>
      </div>
      <div
        id="g-ai1-13"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:37.6518%;margin-top:-6.5px;right:92.4997%;width:64px;"
      >
        <p class="g-pstyle4">Salchow</p>
      </div>
      <div
        id="g-ai1-14"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:41.9454%;margin-top:-6.6px;left:44.4084%;width:51px;"
      >
        <p class="g-pstyle5">1998</p>
      </div>
      <div
        id="g-ai1-15"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:41.9201%;margin-top:-6.5px;left:10.0019%;width:76px;"
      >
        <p class="g-pstyle6">Edge jump</p>
      </div>
      <div
        id="g-ai1-16"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:47.3756%;margin-top:-12.4px;right:39.4743%;width:135px;"
      >
        <p class="g-pstyle7">Counter rotational</p>
        <p class="g-pstyle7">spin increases difficulty</p>
      </div>
      <div
        id="g-ai1-17"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:51.3714%;margin-top:-6.5px;right:92.4355%;width:44px;"
      >
        <p class="g-pstyle4">Lutz</p>
      </div>
      <div
        id="g-ai1-18"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:55.665%;margin-top:-6.6px;left:65.1092%;width:49px;"
      >
        <p class="g-pstyle5">2011</p>
      </div>
      <div
        id="g-ai1-19"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:64.4811%;margin-top:-6.5px;right:92.45%;width:41px;"
      >
        <p class="g-pstyle4">Flip</p>
      </div>
      <div
        id="g-ai1-20"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:67.8601%;margin-top:-6.6px;left:71.8939%;width:51px;"
      >
        <p class="g-pstyle5">2016</p>
      </div>
      <div
        id="g-ai1-21"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:77.8957%;margin-top:-6.5px;right:92.4537%;width:47px;"
      >
        <p class="g-pstyle4">Loop</p>
      </div>
      <div
        id="g-ai1-22"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:81.5796%;margin-top:-6.6px;left:71.8939%;width:51px;"
      >
        <p class="g-pstyle5">2016</p>
      </div>
      <div
        id="g-ai1-23"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:87.0565%;margin-top:-11.5px;left:15.5288%;width:76px;"
      >
        <p class="g-pstyle8">Forewards</p>
        <p class="g-pstyle8">takeoff</p>
      </div>
      <div
        id="g-ai1-24"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:88.2616%;margin-top:-6.5px;right:17.7583%;width:84px;"
      >
        <p class="g-pstyle7">4.5 rotations</p>
      </div>
      <div
        id="g-ai1-25"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:91.3104%;margin-top:-6.5px;right:92.4592%;width:44px;"
      >
        <p class="g-pstyle4">Axel</p>
      </div>
      <div
        id="g-ai1-26"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:94.9942%;margin-top:-6.6px;left:82.8104%;width:53px;"
      >
        <p class="g-pstyle5">2022</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: lg -->
  {#if width && width >= 930 && width < 1200}
    <div id="g-quads-lg" class="g-artboard" style="">
      <div style="padding: 0 0 55.2688% 0;"></div>
      <div
        id="g-quads-lg-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/quads-lg.jpg);"
      ></div>
      <div
        id="g-ai2-1"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:11.3971%;margin-top:-17.6px;left:87.551%;width:112px;"
      >
        <p class="g-pstyle0">All jumps</p>
        <p class="g-pstyle0">land backwards</p>
      </div>
      <div
        id="g-ai2-2"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:12.4752%;margin-top:-9.1px;left:19.9495%;width:53px;"
      >
        <p class="g-pstyle1">1980</p>
      </div>
      <div
        id="g-ai2-3"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:12.4752%;margin-top:-9.1px;left:34.6242%;width:53px;"
      >
        <p class="g-pstyle1">1990</p>
      </div>
      <div
        id="g-ai2-4"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:12.4752%;margin-top:-9.1px;left:49.2988%;width:57px;"
      >
        <p class="g-pstyle1">2000</p>
      </div>
      <div
        id="g-ai2-5"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:12.4752%;margin-top:-9.1px;left:63.9736%;width:53px;"
      >
        <p class="g-pstyle1">2010</p>
      </div>
      <div
        id="g-ai2-6"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:12.4752%;margin-top:-9.1px;left:78.6481%;width:56px;"
      >
        <p class="g-pstyle1">2020</p>
      </div>
      <div
        id="g-ai2-7"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:21.3193%;margin-top:-17.6px;left:14.7929%;width:87px;"
      >
        <p class="g-pstyle0">Backwards</p>
        <p class="g-pstyle0">takeoff</p>
      </div>
      <div
        id="g-ai2-8"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:22.0975%;margin-top:-17.6px;right:11.2711%;width:88px;"
      >
        <p class="g-pstyle2">Land on</p>
        <p class="g-pstyle2">same skate</p>
      </div>
      <div
        id="g-ai2-9"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:24.732%;margin-top:-9.1px;right:92.9909%;width:78px;"
      >
        <p class="g-pstyle3">Toe Loop</p>
      </div>
      <div
        id="g-ai2-10"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:27.6503%;margin-top:-9.1px;left:29.8244%;width:54px;"
      >
        <p class="g-pstyle4">1988</p>
      </div>
      <div
        id="g-ai2-11"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:28.615%;margin-top:-9.1px;left:9.5586%;width:75px;"
      >
        <p class="g-pstyle5">Toe jump</p>
      </div>
      <div
        id="g-ai2-12"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:33.9652%;margin-top:-17.6px;right:11.2558%;width:107px;"
      >
        <p class="g-pstyle2">Land on</p>
        <p class="g-pstyle2">opposite skate</p>
      </div>
      <div
        id="g-ai2-13"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:36.7943%;margin-top:-9.1px;right:92.9425%;width:75px;"
      >
        <p class="g-pstyle3">Salchow</p>
      </div>
      <div
        id="g-ai2-14"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:39.518%;margin-top:-9.1px;left:44.6957%;width:53px;"
      >
        <p class="g-pstyle4">1998</p>
      </div>
      <div
        id="g-ai2-15"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:40.8718%;margin-top:-9.1px;left:9.5586%;width:85px;"
      >
        <p class="g-pstyle5">Edge jump</p>
      </div>
      <div
        id="g-ai2-16"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:45.6383%;margin-top:-17.6px;right:38.7129%;width:154px;"
      >
        <p class="g-pstyle6">Counter rotational</p>
        <p class="g-pstyle6">spin increases difficulty</p>
      </div>
      <div
        id="g-ai2-17"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:49.4402%;margin-top:-9.1px;right:92.993%;width:49px;"
      >
        <p class="g-pstyle3">Lutz</p>
      </div>
      <div
        id="g-ai2-18"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:52.3585%;margin-top:-9.1px;left:67.2783%;width:50px;"
      >
        <p class="g-pstyle4">2011</p>
      </div>
      <div
        id="g-ai2-19"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:61.3079%;margin-top:-9.1px;right:92.9253%;width:46px;"
      >
        <p class="g-pstyle3">Flip</p>
      </div>
      <div
        id="g-ai2-20"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:64.8098%;margin-top:-9.1px;left:72.9043%;width:53px;"
      >
        <p class="g-pstyle4">2016</p>
      </div>
      <div
        id="g-ai2-21"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:73.5647%;margin-top:-9.1px;right:92.9823%;width:53px;"
      >
        <p class="g-pstyle3">Loop</p>
      </div>
      <div
        id="g-ai2-22"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:77.2612%;margin-top:-9.1px;left:72.9043%;width:53px;"
      >
        <p class="g-pstyle4">2016</p>
      </div>
      <div
        id="g-ai2-23"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:82.4088%;margin-top:-16.6px;left:15.2153%;width:85px;"
      >
        <p class="g-pstyle7">Forewards</p>
        <p class="g-pstyle7">takeoff</p>
      </div>
      <div
        id="g-ai2-24"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:83.4788%;margin-top:-9.1px;right:16.538%;width:94px;"
      >
        <p class="g-pstyle6">4.5 rotations</p>
      </div>
      <div
        id="g-ai2-25"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:86.2106%;margin-top:-9.1px;right:92.9065%;width:50px;"
      >
        <p class="g-pstyle3">Axel</p>
      </div>
      <div
        id="g-ai2-26"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:89.518%;margin-top:-9.1px;left:84.0773%;width:55px;"
      >
        <p class="g-pstyle4">2022</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: xl -->
  {#if width && width >= 1200}
    <div id="g-quads-xl" class="g-artboard" style="">
      <div style="padding: 0 0 39.3333% 0;"></div>
      <div
        id="g-quads-xl-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/quads-xl.jpg);"
      ></div>
      <div
        id="g-ai3-1"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:7.4412%;margin-top:-9.1px;left:26.3775%;width:53px;"
      >
        <p class="g-pstyle0">1980</p>
      </div>
      <div
        id="g-ai3-2"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:7.4412%;margin-top:-9.1px;left:37.7504%;width:53px;"
      >
        <p class="g-pstyle0">1990</p>
      </div>
      <div
        id="g-ai3-3"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:7.4412%;margin-top:-9.1px;left:49.1232%;width:57px;"
      >
        <p class="g-pstyle0">2000</p>
      </div>
      <div
        id="g-ai3-4"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:7.4412%;margin-top:-9.1px;left:60.4962%;width:53px;"
      >
        <p class="g-pstyle0">2010</p>
      </div>
      <div
        id="g-ai3-5"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:7.4412%;margin-top:-9.1px;left:71.869%;width:56px;"
      >
        <p class="g-pstyle0">2020</p>
      </div>
      <div
        id="g-ai3-6"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:17.0723%;margin-top:-17.6px;left:22.3812%;width:87px;"
      >
        <p class="g-pstyle1">Backwards</p>
        <p class="g-pstyle1">takeoff</p>
      </div>
      <div
        id="g-ai3-7"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:18.3522%;margin-top:-17.6px;right:20.5429%;width:92px;"
      >
        <p class="g-pstyle2">Land on</p>
        <p class="g-pstyle2">same skate</p>
      </div>
      <div
        id="g-ai3-8"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:20.7887%;margin-top:-9.1px;right:84.2346%;width:78px;"
      >
        <p class="g-pstyle3">Toe Loop</p>
      </div>
      <div
        id="g-ai3-9"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:23.9666%;margin-top:-9.1px;left:34.0306%;width:54px;"
      >
        <p class="g-pstyle4">1988</p>
      </div>
      <div
        id="g-ai3-10"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:24.8053%;margin-top:-9.1px;left:17.5629%;width:75px;"
      >
        <p class="g-pstyle5">Toe jump</p>
      </div>
      <div
        id="g-ai3-11"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:31.276%;margin-top:-17.6px;right:20.4766%;width:113px;"
      >
        <p class="g-pstyle2">Land on</p>
        <p class="g-pstyle2">opposite skate</p>
      </div>
      <div
        id="g-ai3-12"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:33.9243%;margin-top:-9.1px;right:84.2%;width:75px;"
      >
        <p class="g-pstyle3">Salchow</p>
      </div>
      <div
        id="g-ai3-13"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:36.8904%;margin-top:-9.1px;left:45.5558%;width:53px;"
      >
        <p class="g-pstyle4">1998</p>
      </div>
      <div
        id="g-ai3-14"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:38.1528%;margin-top:-9.1px;left:17.1579%;width:85px;"
      >
        <p class="g-pstyle5">Edge jump</p>
      </div>
      <div
        id="g-ai3-15"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:43.5553%;margin-top:-17.6px;right:41.5859%;width:154px;"
      >
        <p class="g-pstyle6">Counter rotational</p>
        <p class="g-pstyle6">spin increases difficulty</p>
      </div>
      <div
        id="g-ai3-16"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:47.6955%;margin-top:-9.1px;right:84.2362%;width:49px;"
      >
        <p class="g-pstyle3">Lutz</p>
      </div>
      <div
        id="g-ai3-17"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:50.8734%;margin-top:-9.1px;left:63.0574%;width:50px;"
      >
        <p class="g-pstyle4">2011</p>
      </div>
      <div
        id="g-ai3-18"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:52.6655%;margin-top:-17.6px;left:85.1854%;width:112px;"
      >
        <p class="g-pstyle1">All jumps</p>
        <p class="g-pstyle1">land backwards</p>
      </div>
      <div
        id="g-ai3-19"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:60.6192%;margin-top:-9.1px;right:84.1838%;width:46px;"
      >
        <p class="g-pstyle3">Flip</p>
      </div>
      <div
        id="g-ai3-20"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:64.4327%;margin-top:-9.1px;left:67.4175%;width:53px;"
      >
        <p class="g-pstyle4">2016</p>
      </div>
      <div
        id="g-ai3-21"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:73.9666%;margin-top:-9.1px;right:84.2279%;width:53px;"
      >
        <p class="g-pstyle3">Loop</p>
      </div>
      <div
        id="g-ai3-22"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:77.9921%;margin-top:-9.1px;left:67.4175%;width:53px;"
      >
        <p class="g-pstyle4">2016</p>
      </div>
      <div
        id="g-ai3-23"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:83.5977%;margin-top:-16.6px;left:22.7085%;width:85px;"
      >
        <p class="g-pstyle7">Forewards</p>
        <p class="g-pstyle7">takeoff</p>
      </div>
      <div
        id="g-ai3-24"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:84.7629%;margin-top:-9.1px;right:24.4003%;width:94px;"
      >
        <p class="g-pstyle6">4.5 rotations</p>
      </div>
      <div
        id="g-ai3-25"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:87.7378%;margin-top:-9.1px;right:84.1692%;width:50px;"
      >
        <p class="g-pstyle3">Axel</p>
      </div>
      <div
        id="g-ai3-26"
        class="g-artwork g-aiAbs g-aiPointText"
        style="top:91.3395%;margin-top:-9.1px;left:76.0766%;width:55px;"
      >
        <p class="g-pstyle4">2022</p>
      </div>
    </div>
  {/if}
</div>
<!-- End ai2html - 2026-02-20 18:21 -->

<!-- Generated by ai2html v0.100.0 - 2026-02-20 18:21 -->
<!-- ai file: quads.ai -->
<style lang="scss">
  #g-quads-box,
  #g-quads-box .g-artboard {
    margin: 0 auto;
  }
  #g-quads-box p {
    margin: 0;
  }
  #g-quads-box .g-aiAbs {
    position: absolute;
  }
  #g-quads-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-quads-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-quads-xs {
    position: relative;
    overflow: hidden;
  }
  #g-quads-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 12px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(84, 138, 164);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-quads-xs .g-pstyle0 {
    height: 12px;
    text-align: right;
    color: rgb(0, 0, 0);
  }
  #g-quads-xs .g-pstyle1 {
    height: 12px;
  }
  #g-quads-xs .g-pstyle2 {
    font-weight: 300;
    height: 12px;
    color: rgb(0, 0, 0);
  }
  #g-quads-xs .g-pstyle3 {
    font-weight: 700;
    height: 12px;
    font-size: 14px;
    color: rgb(0, 0, 0);
  }
  #g-quads-xs .g-pstyle4 {
    font-weight: 300;
    height: 12px;
    text-align: right;
    color: rgb(0, 0, 0);
  }
  #g-quads-xs .g-pstyle5 {
    height: 12px;
    text-align: center;
  }
  #g-quads-xs .g-pstyle6 {
    font-weight: 300;
    height: 12px;
    font-size: 14px;
    color: rgb(0, 0, 0);
  }
  #g-quads-md {
    position: relative;
    overflow: hidden;
  }
  #g-quads-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 300;
    line-height: 12px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-quads-md .g-pstyle0 {
    height: 12px;
    font-size: 14px;
  }
  #g-quads-md .g-pstyle1 {
    font-weight: 400;
    height: 12px;
    font-size: 14px;
  }
  #g-quads-md .g-pstyle2 {
    height: 12px;
  }
  #g-quads-md .g-pstyle3 {
    font-weight: 400;
    height: 12px;
    text-align: right;
    color: rgb(84, 138, 164);
  }
  #g-quads-md .g-pstyle4 {
    font-weight: 400;
    height: 12px;
    text-align: right;
  }
  #g-quads-md .g-pstyle5 {
    font-weight: 700;
    height: 12px;
    font-size: 14px;
  }
  #g-quads-md .g-pstyle6 {
    font-weight: 400;
    height: 12px;
    color: rgb(84, 138, 164);
  }
  #g-quads-md .g-pstyle7 {
    height: 12px;
    text-align: right;
  }
  #g-quads-md .g-pstyle8 {
    line-height: 11px;
    height: 11px;
  }
  #g-quads-lg {
    position: relative;
    overflow: hidden;
  }
  #g-quads-lg p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 300;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-quads-lg .g-pstyle0 {
    height: 17px;
  }
  #g-quads-lg .g-pstyle1 {
    font-weight: 400;
    height: 17px;
    font-size: 15px;
  }
  #g-quads-lg .g-pstyle2 {
    font-weight: 400;
    height: 17px;
    text-align: right;
    color: rgb(84, 138, 164);
  }
  #g-quads-lg .g-pstyle3 {
    font-weight: 400;
    height: 17px;
    font-size: 15px;
    text-align: right;
  }
  #g-quads-lg .g-pstyle4 {
    font-weight: 700;
    height: 17px;
    font-size: 15px;
  }
  #g-quads-lg .g-pstyle5 {
    font-weight: 400;
    height: 17px;
    color: rgb(84, 138, 164);
  }
  #g-quads-lg .g-pstyle6 {
    height: 17px;
    text-align: right;
  }
  #g-quads-lg .g-pstyle7 {
    line-height: 16px;
    height: 16px;
  }
  #g-quads-xl {
    position: relative;
    overflow: hidden;
  }
  #g-quads-xl p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 300;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-quads-xl .g-pstyle0 {
    font-weight: 400;
    height: 17px;
    font-size: 15px;
  }
  #g-quads-xl .g-pstyle1 {
    height: 17px;
  }
  #g-quads-xl .g-pstyle2 {
    font-weight: 400;
    height: 17px;
    font-size: 15px;
    text-align: right;
    color: rgb(84, 138, 164);
  }
  #g-quads-xl .g-pstyle3 {
    font-weight: 400;
    height: 17px;
    font-size: 15px;
    text-align: right;
  }
  #g-quads-xl .g-pstyle4 {
    font-weight: 700;
    height: 17px;
    font-size: 15px;
  }
  #g-quads-xl .g-pstyle5 {
    font-weight: 400;
    height: 17px;
    color: rgb(84, 138, 164);
  }
  #g-quads-xl .g-pstyle6 {
    height: 17px;
    text-align: right;
  }
  #g-quads-xl .g-pstyle7 {
    line-height: 16px;
    height: 16px;
  }

  /* Custom CSS */
  .g-text {
  }
</style>
